var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGogift = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    height: "100px",
    viewBox: "5 5 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A1DF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95,50c0,24.8-20,45-45,45C25.2,95,5,75,5,50S25,5,50,5C74.8,5,95,25.2,95,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,57.7c2,0,3.5-1.5,3.5-4c0-2.4-1.5-3.8-3.5-3.8s-3.5,1.6-3.5,3.8C32.7,56,34.2,57.7,36.2,57.7z  M36.2,48.2c2.9,0,5.3,2.2,5.3,5.5c0,3.3-2.2,5.5-5.3,5.5c-3.1,0-5.3-2.2-5.3-5.5C30.9,50.4,33.2,48.2,36.2,48.2z M63.5,48.7H64v10 h-3.8v-10H63.5z M85.9,50.2c0,1.1-0.9,2.2-2.2,2.2c-1.1,0-2.2-0.9-2.2-2.2c0-1.1,0.9-2.2,2.2-2.2C85,48,85.9,48.9,85.9,50.2z  M29,49.1v9.5h-0.2c-1.6,0.5-2.9,0.9-5.5,0.9c-6,0-9.5-4-9.5-9.1c0-5.5,3.8-9.5,8.9-9.5c2,0,4,0.7,5.8,2.2l0.4,0.4l-1.3,1.5 l-0.4-0.4c-1.1-1.1-2.7-1.8-4.6-1.8c-4.2,0-6.9,3.3-6.9,7.5c0,4.9,3.3,7.5,7.5,7.5c2.2,0,3.5-0.5,3.6-0.5v-6h-4.4v-2H29z  M81.2,56.7l0.5,0.9l-0.4,0.2c0,0.2-0.2,0.2-0.2,0.2c-0.5,0.4-1.8,0.9-3.1,0.9c-2,0-3.8-1.1-3.8-3.6v-9.1h3.8v2.6h2.2v3.1h-2.2v2.7 c0,0.7,0.2,0.9,0.5,0.9c0.2,0,0.5-0.2,0.7-0.4l0.7-0.4l0.2,0.2v0.4C80.6,55.6,80.8,56.2,81.2,56.7L81.2,56.7z M71.3,48.7h1.5v3.1 H70v6.9h-4.2V48c0-2.2,0.5-6.2,4.9-6.2c1.5,0,2.9,0.7,3.6,1.5l-2.2,2.5c-0.4-0.2-0.7-0.4-1.1-0.4c-1.1,0-1.1,1.3-1.1,2.2v1.1 L71.3,48.7L71.3,48.7z M58,48.7h-0.5v9.1c0,0.2,0,0.2-0.2,0.2c-1.1,0.5-3.3,1.1-5.5,1.1c-6.2,0-9.5-3.8-9.5-9.3 c0-4.9,3.6-9.3,9.1-9.3c1.8,0,3.6,0.5,5.1,1.5c0.4,0.4,0.9,0.7,1.3,1.1L55.5,46c-1.1-0.9-2.5-1.5-3.8-1.5c-3.1,0-4.9,2.5-4.9,5.8 c0,3.1,2,5.5,5.3,5.5c1.5,0,2-0.4,2-0.4v-3.6h-3.1v-3.1L58,48.7L58,48.7z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGogift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gogift.97081af251f094991a3fdb3ca2617beb.svg";